// JsFromRoutes CacheKey 1a3115944dc5f4c72616957fffec99c3
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:account_id/visitors'),
}
